import { render, staticRenderFns } from "./CreateOpportunityBtn.vue?vue&type=template&id=2b670f34"
import script from "./CreateOpportunityBtn.vue?vue&type=script&lang=ts"
export * from "./CreateOpportunityBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports